import { apiFetch } from 'services/apiClient';
import { Page } from '../../../types/Page';
import {
  ReportFormat,
  ReportFormatAttributeStatus,
  ReportFormatControlArea,
  ReportFormatControlAreaCleanupResponse,
  ReportFormatControlAreaCompleteQuestionAudit,
  ReportFormatMissingControlAreaQuestionClonePreview,
  ReportFormatMissingControlAreaQuestionCloneResponse,
  ReportFormatFunctionTagResponse,
  ReportFormatMonthlyStatus,
  ReportFormatStatusSummary,
  ReportFormatQuestionListItem,
} from '../types/ReportFormat';

export const listReportFormats = (page = 0, size = 10, sort?: string, query?: string): Promise<Page<ReportFormat>> =>
  apiFetch('/report-formats?page=' + page + '&size=' + size + (sort ? '&sort=' + sort : '') + (query ? '&' + query : ''));
export const listReportFormatsAll = (sort?: string): Promise<ReportFormat[]> =>
  apiFetch('/report-formats/all' + (sort ? '?sort=' + encodeURIComponent(sort) : ''));
export const getMissingReportFormatDrawerList = (): Promise<ReportFormat[]> =>
  apiFetch('/report-formats/missing-drawer-list');
export const listReportFormatAttributeStatuses = (): Promise<ReportFormatAttributeStatus[]> =>
  apiFetch('/report-formats/attribute-statuses');
export const getReportFormat = (id: number): Promise<ReportFormat> => apiFetch('/report-formats/' + id);
export const listReportFormatQuestions = (id: number, query?: string): Promise<ReportFormatQuestionListItem[]> =>
  apiFetch(`/report-formats/${id}/questions/list${query ? `?${query}` : ''}`);
export const createReportFormat = (data: any): Promise<ReportFormat> =>
  apiFetch('/report-formats', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data) });
export const updateReportFormat = (id: number, data: any): Promise<ReportFormat> =>
  apiFetch('/report-formats/' + id, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data) });
export const deleteReportFormat = (id: number): Promise<void> =>
  apiFetch('/report-formats/' + id, { method: 'DELETE' });

export const cloneReportFormat = (id: number, attributeId?: number): Promise<ReportFormat> =>
  apiFetch('/report-formats/' + id + '/clone' + (attributeId ? '?attributeId=' + attributeId : ''), { method: 'POST' });

export const setReportFormatActive = (id: number, active: boolean): Promise<ReportFormat> =>
  apiFetch('/report-formats/' + id + '/active?active=' + (active ? 'true' : 'false'), {
    method: 'PUT',
  });

export const getReportFormatFunctionTags = (id: number): Promise<ReportFormatFunctionTagResponse> =>
  apiFetch('/report-formats/' + id + '/function-tags');

export const getReportFormatControlAreas = (id: number): Promise<ReportFormatControlArea[]> =>
  apiFetch('/report-formats/' + id + '/control-areas');

export const getReportFormatControlAreaCompleteQuestions = (id: number): Promise<ReportFormatControlAreaCompleteQuestionAudit> =>
  apiFetch('/report-formats/' + id + '/control-area-complete-questions');

export const clearReportFormatControlAreasFromCompleteQuestions = (id: number): Promise<ReportFormatControlAreaCleanupResponse> =>
  apiFetch('/report-formats/' + id + '/control-area-complete-questions/control-areas', { method: 'DELETE' });

export const getMissingControlAreaQuestionClonePreview = (id: number): Promise<ReportFormatMissingControlAreaQuestionClonePreview> =>
  apiFetch('/report-formats/' + id + '/missing-control-area-question-clones');

export const createMissingControlAreaQuestionClones = (id: number): Promise<ReportFormatMissingControlAreaQuestionCloneResponse> =>
  apiFetch('/report-formats/' + id + '/missing-control-area-question-clones', { method: 'POST' });

export const getReportFormatMonthlyStatus = (month?: string): Promise<ReportFormatMonthlyStatus[]> =>
  apiFetch('/report-formats/monthly-status' + (month ? '?month=' + encodeURIComponent(month) : ''));

export const getReportFormatStatusSummary = (): Promise<ReportFormatStatusSummary> =>
  apiFetch('/report-formats/status-summary');

export const getReportFormatWeeklyStatus = (weekStart: string): Promise<ReportFormatMonthlyStatus[]> =>
  apiFetch('/report-formats/weekly-status?weekStart=' + encodeURIComponent(weekStart));
